<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'ONT Statistics Traffic'"
          style="height: 100%"
          :closeButton="false"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadOntStatisticsTraffic()"
                  class="btn"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <form class="form-horizontal">
            <div
              class="form-group"
              v-for="(value, key) in ontStatistics"
              :key="key"
            >
              <div class="col-lg-4">
                <label>{{ value.k }}</label>
              </div>
              <div class="col-lg-8">
                <label>{{ value.v }}</label>
              </div>
            </div>
          </form>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontStatistics",
  data() {
    return {
      ontStatistics: "",
    }
  },
  props: ["ontIndex"],
  components: {
    BlockCntr,
  },
  created() {
    this.loadOntStatisticsTraffic()
  },
  methods: {
    loadOntStatisticsTraffic() {
      get("ontStatistics?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontStatistics = res.data))
        .catch((err) => {
          this.ontStatistics = en.ontStatistics
        })
    },
  },
}
</script>